import { PhotoCardModule } from '../bdc/bdc-property-detail-dialog/shared/photo-card/photo-card.module'
import { AgodaContractsComponent } from './contracts/agoda-contracts.component'
import { AgodaPhotosComponent } from './agoda-photos/agoda-photos.component'
import { AgodaCreatePropertyDialogComponent } from './create-property/agoda-create-property-dialog.component'
import { AgodaPropertyDetailsComponent } from './property/agoda-property-details.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { AgodaContentDialogComponent } from '@tv3/containers/channels/channel-content/agoda/agoda-content-dialog.component'
import { AgodaContentRateSetupComponent } from '@tv3/containers/channels/channel-content/agoda/rate/agoda-content-rate-setup.component'
import { AgodaContentPropertySetupComponent } from '@tv3/containers/channels/channel-content/agoda/property/agoda-content-property-setup.component'
import { AgodaContentProductSetupComponent } from '@tv3/containers/channels/channel-content/agoda/product/agoda-content-product-setup.component'
import { AgodaContentRoomSetupComponent } from '@tv3/containers/channels/channel-content/agoda/room/agoda-content-room-setup.component'
import { AgodaContentStepInstructionFormComponent } from './property/step-forms/step-instructions/agoda-content-step-instruction-form.component'
import { AgodaContentStepAdditionalFeesFormComponent } from '@tv3/containers/channels/channel-content/agoda/property/step-forms/step-additional-fees/agoda-content-step-additional-fees-form.component'
import { ChannelContentLibraryModule } from '@tokeet-frontend/channel-content'

const components = [
  AgodaContractsComponent,
  AgodaPhotosComponent,
  //
  AgodaContentPropertySetupComponent,
  AgodaCreatePropertyDialogComponent,
  AgodaPropertyDetailsComponent,
  AgodaContentRoomSetupComponent,
  AgodaContentRateSetupComponent,
  AgodaContentProductSetupComponent,
  AgodaContentStepInstructionFormComponent,
  AgodaContentStepAdditionalFeesFormComponent,
  AgodaContentDialogComponent,
]

@NgModule({
  imports: [PhotoCardModule, SharedModule, CommonModule, ChannelContentLibraryModule],
  declarations: [...components],
  exports: [...components],
})
export class AgodaContentModule {}
